export const FAQs = (props) => [
  {
    question: "Why should I use Fale?",
    answer: (
      <>
        <p>
          Fale has been designed from the ground up with the home cook in mind.
          <br />
          Here are some features and reasons you should use Fale:
        </p>
        <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
          <li>Secure, fast and consistent payment collection</li>
          <li>Order tracking and management consolidated into one platform</li>
          <li>Improved customer experience</li>
          <li>Streamline the ordering process for your customers</li>
          <li>
            You will be supporting a local Māori owned business in Auckland
          </li>
          <li>
            Your customers will receive important notifications about their
            orders
          </li>
          <li>
            You will receive important notifications about your customers and
            their orders
          </li>
          <li>
            Become part of the Fale Marketplace and gain access to Fale's market
            reach as it becomes popular with the locals
          </li>
        </ul>
      </>
    ),
  },
  {
    question: "How much does Fale charge and is there a joining fee?",
    answer: (
      <>
        There is <strong>no joining fee</strong> or any start up costs. <br />
        <p>Billing and fees summary</p>
        <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
          <li>
            Fale charges a <strong>15% + $0.30 service fee</strong> of the total
            order
          </li>
          <li style={{ paddingTop: "5px" }}>
            All transactions will be viewable in the
            <strong> Fale Portal</strong>
          </li>
          <li style={{ paddingTop: "5px" }}>
            Pending payouts will be viewable in the
            <strong> Fale Portal</strong>
          </li>
          <li style={{ paddingTop: "5px" }}>
            Fale takes approximately <strong>7 days</strong> to payout to your
            nominated bank account from the time the money is collected
          </li>
        </ul>
        <br />
        <p>
          <strong>Example transaction:</strong>
          <span className="ms-4">
            <br />
            Order Total: <strong>$100.00</strong>
            <br />
            Fale service fee: <strong>$15.30 (15% + $0.30)</strong>
            <br />
            <strong>Kitchen payout: $84.70</strong>
            <br />
          </span>
        </p>
      </>
    ),
  },
  {
    question: "Who made Fale?",
    answer: (
      <>
        <a
          href="https://nz.linkedin.com/in/tino-laomahei-100a345a"
          target="_blank"
          rel="noreferrer"
        >
          Tino Laomahei
        </a>{" "}
        is the creator of Fale and will help you with any questions or concerns
        you have, send any feedback or questions to{" "}
        <a href="mailto:tino@fale.co.nz">tino@fale.co.nz</a>
      </>
    ),
  },
  {
    question: "How do I start selling my dishes?",
    answer: (
      <>
        Once your kitchen has been approved by Tino, you will be able to go
        live. Once your kitchen is live, you can start by telling your customers
        to order through the{" "}
        <a
          href={`https://app.fale.co.nz${
            props ? `/kitchen?id=${props.selectedKitchen?.uuid}` : ""
          }`}
          target="_blank"
          rel="noreferrer"
        >
          Fale App
        </a>
        <br />
        <br />
        <p>This is how you start selling your dishes:</p>
        <ol>
          <li>Wait for your kitchen to be approved</li>
          <li>Add all your dishes to Fale</li>
          <li>
            Update your settings to include your pickup instructions, whether
            you support deliveries and/or pickup only
          </li>
          <li>Set your kitchen as "live"</li>
          <li>
            Send everyone you know your{" "}
            <a
              href={`https://app.fale.co.nz${
                props ? `/kitchen?id=${props.selectedKitchen?.uuid}` : ""
              }`}
              target="_blank"
              rel="noreferrer"
            >
              Fale link
            </a>
          </li>
        </ol>
      </>
    ),
  },
  {
    question: "Do I have to be a registered business to use Fale?",
    answer: (
      <>
        No, we do however <strong>recommend</strong> that you comply with the NZ
        food act of 2014 and also read our{" "}
        <strong>
          <a
            href="https://fale.co.nz/kitchen-terms"
            target="_blank"
            rel="noreferrer"
          >
            terms and conditions
          </a>
        </strong>
        . We are not responsible for the legal status of your kitchen.
      </>
    ),
  },
  {
    question: "When will I get my payouts?",
    answer: (
      <>
        Payouts are scheduled daily, each payout takes roughly{" "}
        <strong>7 days</strong> to process to your nominated bank account.
      </>
    ),
  },
  {
    question:
      "How do I know the payouts will arrive in my bank account? How can I trust Fale?",
    answer: (
      <>
        If you have any concerns about trust, you can have a one on one chat
        with Tino.
        <br />
        <br /> We could also setup a trial where Tino will buy a few orders from
        your kitchen and we can review what the payouts look like after 7 days.
      </>
    ),
  },
  {
    question: "Can I deliver to my customers?",
    answer: (
      <>
        Of course! You can set a delivery fee when accepting an order, you'll
        need to determine what delivery fee is appropriate for their address.
      </>
    ),
  },
];
